import { createClasses } from 'src/theme/create-classes';

// ----------------------------------------------------------------------

export const snackbarClasses = {
  root: createClasses('snackbar__root'),
};
